module.exports = __webpack_public_path__ + "img/1476421535.e6696868.jpg";